import { useTranslation } from "react-i18next"
import { Box, Flex, IconButton, Text } from "@chakra-ui/react"
import { MdClose } from "react-icons/md"
import UnitName from "../../Dealer/CurrentUnits/UnitName"
import { SolidGreenButton } from "../../common/Buttons"
import { colors } from "../../../utilities/colors"

export default function QuoteList({ units, onRemove, onGetQuote }) {
  const { t } = useTranslation()

  if (units.length === 0) {
    return (
      <Flex
        w="full"
        py={4}
        px={2}
        alignItems="center"
        justifyContent="center"
        borderBottom="2px solid"
        borderColor={colors.grey700}
        color={colors.grey400}
      >
        <Text fontSize="sm" fontStyle="italic">
          {t('Add vehicles to quote')}
        </Text>
      </Flex>
    )
  }

  return (
    <Box
      borderBottom="2px solid"
      borderColor={colors.grey700}
      bg={`${colors.green}08`}
    >
      {units.map((unit) => (
        <Flex
          key={unit.id}
          w="full"
          py={2}
          px={2}
          alignItems="center"
          color={colors.grey300}
          borderBottom="1px solid"
          borderColor={colors.grey700}
        >
          <Flex flexDir="column" flex={1} minW={0} overflow="hidden">
            <UnitName unit={unit} />
            {unit.attributes.vin && (
              <div className="text-xs truncate">{unit.attributes.vin}</div>
            )}
          </Flex>
          <IconButton
            aria-label={t('Remove from quote')}
            onClick={() => onRemove(unit)}
            variant="ghost"
            size="sm"
            color={colors.grey300}
            _hover={{ bg: colors.grey700, color: colors.red }}
          >
            <MdClose size={20} />
          </IconButton>
        </Flex>
      ))}
      <Box p={2}>
        <SolidGreenButton
          text={`${t('Get Quote')} (${units.length})`}
          onClick={onGetQuote}
          style="w-full"
        />
      </Box>
    </Box>
  )
}
